import { buttonDisabledStyleMap, buttonStyle } from './buttonClassNameConstants.js';
/** @deprecated */
export const getDisabledButtonClasses = ({ className, rounded, version, }) => [
    'inline-block',
    buttonStyle,
    version ? buttonDisabledStyleMap[version] : '',
    rounded ? 'rounded-full' : 'rounded-md',
    className,
].join(' ');
//# sourceMappingURL=getDisabledButtonClasses.js.map